import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getLiteTradeConfig, getLiteTradeConfigError } from '../../modules/LiteTrade/liteTradeSelectors';
import LiteTradeWSConnector from './LiteTradeWSConnector';
import useEffectOnce from '../../hooks/useEffectOnce';
import { initLiteTradeAction, pingLiteTradeAction } from '../../modules/LiteTrade/liteTradeActions';
import { NoConnection } from '../../presentationalComponents/NoConnection/NoConnection';
import appHistory from '../../app/appHistory';
import { RouterPaths } from '../../app/appConstants';
import { useLangContext } from '../LangProvider/LangProviderContext';
import { getOnlineStatus } from '../../modules/InternetConnection/internetConnectionSelectors';

/**
 * Раньше это был провайдер, теперь просто коннектор с автопингом на WebSocket
 */
function LiteTradeProvider({ withWS }) {
    const dispatch = useDispatch();

    const liteTradeConfig = useSelector(getLiteTradeConfig);
    const liteTradeConfigError = useSelector(getLiteTradeConfigError);
    const isOnline = useSelector(getOnlineStatus);

    useEffectOnce(() => {
        dispatch(initLiteTradeAction());
    });

    useEffect(() => {
        const timer = setInterval(() => {
            dispatch(pingLiteTradeAction());
        }, 1000 * 60);
        return () => {
            clearTimeout(timer);
        };
    }, [dispatch]);

     const { getLangPath } = useLangContext();
     const lang = useCallback(
         (key: string) => {
             const result = getLangPath(key);
             if (result === key) {
                 return undefined;
             }
             return result;
         },
         [getLangPath],
     );

     const onClick = useCallback(() => {
         appHistory.push(`${RouterPaths.support}`);
     }, []);
     
    return <>
            {withWS && liteTradeConfigError && isOnline && 
                <NoConnection
                    onClick={onClick}
                    title={lang('error.connection.dx.title')}
                    description={lang('error.connection.dx.description')}
                    btnText={lang('error.connection.dx.action')}
                />
            }
            {!!liteTradeConfig && <LiteTradeWSConnector />}
    </>;
}

export default LiteTradeProvider;
